/**
 * Admin route component to guard admin-only routes
 *
 * @author Claude
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ReactNode } from 'react';

interface AdminRouteProps {
  children: ReactNode;
}

/**
 * Route wrapper that checks for admin role
 * Redirects non-admin users to the dashboard
 * @param {AdminRouteProps} props - Component props
 * @returns {JSX.Element} Admin route or redirect to dashboard
 */
export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { user } = useAuth();

  if (user?.role !== 'admin' && user?.role !== 'super_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
